import api from 'services/api';

/**
 * A one-time URL that opens an app's frontend as the signed-in admin. The
 * dashboard session stays in the dashboard; the URL carries a code the
 * frontend's proxy trades for its own access.
 * @param {string} appId
 * @param {string} url the frontend URL to open
 * @param {string} [storefrontId] set for a storefront preview the app runs
 * @returns {Promise<string>}
 */
export async function getFrontendAccessUrl(appId, url, storefrontId) {
  const { pathname, search, hash } = new URL(url, window.location.href);

  const result = await api.post(`/apps/${appId}/frontend-access`, {
    path: pathname + search + hash,
    ...(storefrontId && { storefront_id: storefrontId }),
  });

  return result.url;
}

/**
 * Open an app's frontend in a new tab as the signed-in admin.
 * @param {string} appId
 * @param {string} url the frontend URL to open
 * @returns {void}
 */
export function openFrontendAccessUrl(appId, url) {
  // Opened during the click, so the browser doesn't block it as a popup
  const tab = window.open('', '_blank');

  if (!tab) {
    return;
  }

  // The app's page must not control the dashboard tab
  tab.opener = null;

  getFrontendAccessUrl(appId, url).then(
    (accessUrl) => {
      tab.location.href = accessUrl;
    },
    () => tab.close(),
  );
}
